import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { AjEventAwardUnit, SelectAjTemplate } from 'containers/sections/aj-events'
import { Divider, FloatingBar, FormButton } from 'components/misc'
import { AJAssessor, AJEventAddress, AJEventDates, AJGeneralInfo } from 'components/sections/adventurous-journeys'
import { form, permissions as appPermissions } from 'helpers/decorators'
import {
  apiActivities,
  apiAjEvents,
  apiAjTemplates,
  apiAssessors,
  apiCodeLists,
  apiCommon,
  apiConfiguration,
  apiLists
} from 'helpers/decorators/api'
import { validate } from 'models/aj-events'
import { get } from 'lodash'
import { ACTIVITY_CATEGORIES, CONFIGURATION_KEYS } from '../../../../constants/enums'
import { connect } from 'react-redux'
import { checkAssessorEmailAvailability } from '../../../../redux/modules/api/asyncValidations'
import { asyncValidate } from '../../../../models/aj-events/validateAssessor'


@connect(({ auth }) => ({
  authOrgId: get(auth, 'organization.id')
}), { checkAssessorEmailAvailability })
@apiConfiguration()
@appPermissions()
@form({
  form: 'ajEventCreate',
  validate,
  asyncValidate
})
@apiCodeLists([
  'ajEventCategories',
  'modeOfTransportTypeList',
  'awardLevelTypes',
  'titles'
])
@apiLists({ transportationMode: true })
@apiAssessors()
@apiCommon({
  countries: true
})
@apiActivities({
  template: 'nested',
  activityCategories: false,
  ajTypes: true
})
@apiAjEvents()
@apiAjTemplates()
class AjEventNew extends Component {
  static propTypes = {
    pristine: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    codeLists: PropTypes.object.isRequired,
    lists: PropTypes.object.isRequired,
    permissions: PropTypes.object,
    common: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    values: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    createAjEvent: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    onActivityParentChange: PropTypes.func.isRequired,
    onAjTypeChange: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
  }

  async componentWillMount() {
    await this.handleUpdate({}, this.props)
  }
  async componentWillUpdate(newProps) {
    await this.handleUpdate(this.props, newProps)
  }
  getOrgId(props) {
    const authOrgId = get(props, 'authOrgId')
    const assignToOrganizationId = get(props, 'values.assignToOrganizationId')

    return assignToOrganizationId ?? authOrgId
  }
  getSubCategory(props) {
    return get(props, 'values.activityCategory.id')
  }
  getIsAssessorManagementEnabled(props) {
    return get(props, `configuration.valuesByOrganizationId.${this.getOrgId(props)}.${CONFIGURATION_KEYS.manageAssessors.id}.booleanValue`)
  }
  async handleUpdate(props, newProps) {
    const newOrgId = this.getOrgId(newProps)
    const newSubCategory = this.getSubCategory(newProps)
    const newIsAssessorManagementEnabled = this.getIsAssessorManagementEnabled(newProps)
    const orgIdChanged = (newOrgId !== this.getOrgId(props))
    const subCategoryChanged = (newSubCategory !== this.getSubCategory(props))
    const isAssessorManagementEnabledChanged = (newIsAssessorManagementEnabled !== this.getIsAssessorManagementEnabled(props))

    if (orgIdChanged) {
      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.manageAssessors.id, newOrgId)
    }
    if ((orgIdChanged || subCategoryChanged || isAssessorManagementEnabledChanged)
        && newIsAssessorManagementEnabled && newSubCategory && newSubCategory !== ACTIVITY_CATEGORIES.other.id && newOrgId
    ) {
      this.props.onGetAvailableAssessorsForActivityCategory(newOrgId, newSubCategory)
    }
  }

  render() {
    const {
      codeLists,
      common,
      activities,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      handleSubmit,
      createAjEvent,
      change,
      values,
      onActivityParentChange,
      onAjTypeChange,
      permissions,
      initialize,
      lists
    } = this.props

    const subcategoryValue = get(values, 'activityCategory.id')
    const setupAssessorId = get(values, 'setupAssessorId')
    const setupSupervisorId = get(values, 'setupSupervisorId')
    const isAssessorManagementEnabled = this.getIsAssessorManagementEnabled(this.props)

    return (
        <div>
          <form className="form" onSubmit={handleSubmit(createAjEvent)}>
            <div className="row">
              <div className="col-xs-6">
                <div className="base-margin--bottom">
                  <SelectAjTemplate change={change} activities={activities} />
                </div>
                <Divider />
                {!permissions.isLeader && (
                    <div className="row">
                      <div className="col-xs-6 base-margin--top">
                        <AjEventAwardUnit values={values} initialize={initialize} />
                      </div>
                    </div>
                )}

                <AJGeneralInfo
                    data={values}
                    eventTypes={codeLists.ajEventCategories.list}
                    activities={activities}
                    transportationModeList={lists.transportationMode.list}
                    awardLevels={codeLists.awardLevelTypes.list}
                    onActivityParentChange={onActivityParentChange}
                    onAjTypeChange={onAjTypeChange}
                    change={change}
                />
              </div>

              <div className="col-xs-6 ">
                <AJAssessor
                    title="Assessor"
                    intlKey="moduleTitle.assessor"
                    formPrefix="assessor"
                    titles={codeLists.titles.list}
                    supervisor={false}
                    subcategoryValue={subcategoryValue}
                    setupAssessorId={setupAssessorId}
                    isAssessorManagementEnabled={isAssessorManagementEnabled}
                    initialize={initialize}
                    change={change}
                    values={values}
                    orgId={this.getOrgId(this.props)}
                />

                <AJAssessor
                    title="Supervisor"
                    intlKey="moduleTitle.supervisor"
                    disabledIntlKey="label.supervisor_disabled_for_other_activity"
                    disabledDefault="Supervisor selection is disabled for other activity."
                    formPrefix="supervisor"
                    titles={codeLists.titles.list}
                    supervisor={true}
                    subcategoryValue={subcategoryValue}
                    setupSupervisorId={setupSupervisorId}
                    isAssessorManagementEnabled={isAssessorManagementEnabled}
                    initialize={initialize}
                    values={values}
                    change={change}
                    orgId={this.getOrgId(this.props)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-6">
                <AJEventDates values={values} />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <AJEventAddress
                    change={change}
                    countries={common.countries.list}
                />
              </div>
            </div>

            <FloatingBar>
              <FormButton
                  pristine={pristine}
                  submitSucceeded={submitSucceeded}
                  submitFailed={submitFailed}
                  invalid={invalid}
                  type="submit"
                  intlKey="button.save"
              >
                Save
              </FormButton>
            </FloatingBar>
          </form>
        </div>
    )
  }
}

export default AjEventNew
